import { flow, SnapshotOut, types } from 'mobx-state-tree'
import { Paginator } from 'ogram-react'

import { DataStore } from './data-store/data-store'

export const DISPUTE_TYPE_OVERTIME = 1
export const DISPUTE_TYPE_NO_SHOW = 2

export const DISPUTE_STATUS_RESOLVED = 2
export const DISPUTE_STATUS_RAISED = 3
export const DISPUTE_STATUS_DECLINED = 4

const DisputeModel = types.model('Dispute', {
  id: types.identifierNumber,
  type: types.number,
  designation_id: types.number,
  designation_name: types.string,
  designation_image: types.maybeNull(types.string),
  client_name: types.string,
  location: types.string,
  shift_start_time: types.number,
  sp_checkin_time: types.maybeNull(types.number),
  sp_checkout_time: types.maybeNull(types.number),
  sp_name: types.string,
  sp_image: types.maybeNull(types.string),
  sp_total_hours: types.maybeNull(types.number),
  client_checkin_time: types.maybeNull(types.number),
  client_checkout_time: types.maybeNull(types.number),
  client_total_hours: types.maybeNull(types.number),
  status: types.number,
  expires_at: types.number,
  sp_comment: types.maybeNull(types.string),
  sp_file: types.maybeNull(types.string),
})

export const DisputesModel = types.model('DisputesModel', {
  list: types.map(DisputeModel),
  currentPage: types.number,
  totalPages: types.number,
  nextPage: types.maybeNull(types.number),
  total: types.number,
})

export const disputesActions = (self: DataStore) => ({
  getDisputes: flow(function* ({ page }: { page?: number }) {
    if (page === 1) {
      self.disputes.list.clear()
      self.disputes.nextPage = 1
    }

    const nextPage = self.disputes.nextPage
    if (nextPage) {
      const { list, paginator } = (yield self.request('get', `client/disputes?page=${nextPage}`)) as {
        list: DisputeSnapshot[]
        paginator?: Paginator
      }

      list.forEach(item => {
        self.disputes.list.set(item.id, item)
      })

      self.disputes.totalPages = Number(paginator?.last_page)
      self.disputes.currentPage = nextPage
      self.disputes.total = Number(paginator?.total)
      self.disputes.nextPage = paginator?.next_page ?? null
    }
  }),

  resolveDispute: flow(function* ({ id }: { id: number }) {
    yield self.request('post', `client/disputes/${id}/resolve`)

    const dispute = self.disputes.list.get(String(id))
    if (dispute) {
      dispute.status = DISPUTE_STATUS_RESOLVED
    }
  }),

  declineDispute: flow(function* ({ id }: { id: number }) {
    yield self.request('post', `client/disputes/${id}/decline`)

    const dispute = self.disputes.list.get(String(id))
    if (dispute) {
      dispute.status = DISPUTE_STATUS_DECLINED
    }
  }),
})

export const disputesViews = (self: DataStore) => ({
  get disputesList() {
    return Array.from(self.disputes.list.values())
  },
  get disputesNextPage() {
    return self.disputes.nextPage
  },
})

export type DisputeSnapshot = SnapshotOut<typeof DisputeModel>
